import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AssetComponent from "components/core/asset/asset-component";
import classnames from "classnames";
import { StyledTabsLabelsComponent } from "./tabs-labels-component.scss";
const TabsLabelsComponent = ({ labels, selectedLabelIndex, progressbarColor, transitionTime, onSelectionChanges, tabLabelHeight })=>/*#__PURE__*/ _jsx(StyledTabsLabelsComponent, {
        tabLabelHeight: tabLabelHeight,
        progressbarColor: progressbarColor,
        transitionTime: transitionTime,
        className: "tabs-labels-component",
        children: labels.map((label, index)=>/*#__PURE__*/ _jsxs("div", {
                onClick: ()=>onSelectionChanges(index),
                className: classnames("label", {
                    active: !!transitionTime,
                    selected: selectedLabelIndex === index
                }),
                children: [
                    /*#__PURE__*/ _jsx(AssetComponent, {
                        image: {
                            src: label
                        }
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "underline-placeholder"
                    })
                ]
            }, index))
    });
export default TabsLabelsComponent;
